import { z } from 'zod'

export const gastoSchema = z
  .object({
    monto: z.coerce.number().positive('El monto debe ser mayor a 0'),
    // concepto y categoria_id son requeridos solo para gastos comunes (superRefine):
    // en una transferencia el concepto lo autogenera la RPC y no lleva categoría.
    concepto: z.string(),
    fecha: z.string().min(1, 'La fecha es requerida'),
    cuenta_id: z.string().min(1, 'Debe seleccionar una cuenta'),
    categoria_id: z.string(),
    moneda: z.enum(['ARS', 'USD']).default('ARS'),
    estado_pago: z.enum(['pagado', 'pendiente']).default('pagado'),
    observaciones: z.string().nullable().optional(),
    es_transferencia: z.boolean().default(false),
    cuenta_destino_id: z.string().nullable().optional(),
  })
  .superRefine((value, ctx) => {
    if (value.es_transferencia) {
      if (!value.cuenta_destino_id) {
        ctx.addIssue({
          code: 'custom',
          path: ['cuenta_destino_id'],
          message: 'Debe seleccionar la cuenta destino',
        })
      } else if (value.cuenta_destino_id === value.cuenta_id) {
        ctx.addIssue({
          code: 'custom',
          path: ['cuenta_destino_id'],
          message: 'La cuenta destino debe ser distinta de la de origen',
        })
      }
      return
    }
    if (!value.concepto) {
      ctx.addIssue({
        code: 'custom',
        path: ['concepto'],
        message: 'El concepto es requerido',
      })
    }
    if (!value.categoria_id) {
      ctx.addIssue({
        code: 'custom',
        path: ['categoria_id'],
        message: 'Debe seleccionar una categoría',
      })
    }
  })

export type GastoFormValues = z.infer<typeof gastoSchema>

export const DEFAULT_GASTO_VALUES: GastoFormValues = {
  monto: 0,
  concepto: '',
  fecha: new Date().toISOString().split('T')[0],
  cuenta_id: '',
  categoria_id: '',
  moneda: 'ARS',
  estado_pago: 'pagado',
  observaciones: null,
  es_transferencia: false,
  cuenta_destino_id: null,
}
